import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Login } from 'src/app/model/common';
import { Globals } from '../globals';
import { MenuMasterData, UserData } from '../model/MenuMasterData';
import { EmployeeProfile } from '../model/useraccessdata';


@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(private http: HttpClient, private globals: Globals) { }


    getLoginList(OL: Login): Observable<Login[]> {
        var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
        return this.http.post<Login[]>(this.globals.APIURL + '/Home/Login', OL, { headers: reqHeader });
    }

    //getUserLoginList(payload: any) {
    //    return this.http.post<any>(this.globals.APIURLFF + '/Login/ValidateLogin/', payload);
    //}
    getUserLoginList(OL: Login): Observable<Login[]> {
        return this.http.post<any>(this.globals.APIURL + '/Home/GetLoginValidation/', OL);
    }
    getUserPermissionUpdateList(payload: any) {
        return this.http.post<any>(this.globals.APIURLFF + '/Login/GeneratePermissionObject_Update/', payload);
    }
    getUserPermissionCombinedList(payload: any) {
        return this.http.post<any>(this.globals.APIURLFF + '/Login/GetUserPermissionObjectCombinedRoles/', payload);
    }
    GetAllMenuList(payload: any): Observable<any> {
        return this.http.post<any>(this.globals.APIURLFF + '/Login/GetHeaderMenu', payload);
    }

    GetOverAllMenuList(payload: any): Observable<any> {
        return this.http.post<any>(this.globals.APIURLFF + '/Login/GetAllMenulist', payload);
    }
    //GetOverAllMenuListByMainMenu(payload: any): Observable<any> {
    //    return this.http.post<any>(this.globals.APIURLFF + '/Login/GetAllMenulistByMainMenu', payload);
    //}
    //GetOverAllMenuListByMainMenu(OL:MenuMasterData): Observable<MenuMasterData[]> {
    //    return this.http.post<any>(this.globals.APIURL + '/MenuMaster/MainMenu', OL);
    //}

    GetUserPermissionObject(OL: MenuMasterData): Observable<MenuMasterData[]> {
        return this.http.post<any>(this.globals.APIURL + '/MenuMaster/UserPermissionObject', OL);
    }
    GetUserReportPermissionObject(OL: MenuMasterData): Observable<MenuMasterData[]> {
        return this.http.post<any>(this.globals.APIURL + '/MenuMaster/UserReportPermissionObject', OL);
    }

    GetUserOffice(OL: MenuMasterData): Observable<MenuMasterData[]> {
        return this.http.post<any>(this.globals.APIURL + '/MenuMaster/UserRoleOffice', OL);
    }

    GetUserOfficeForViewList(UserID): Observable<MenuMasterData[]> {

        return this.http.get<MenuMasterData[]>(this.globals.APIURL + '/MenuMaster/GetUserOfficeForViewList/' + UserID);
    }
    GenerateUserPermissionObject(payload1: any) {

        return this.http.post<any>(this.globals.APIURLFF + '/Login/GeneratePermissionObject/', payload1);
    }

    GetUserActiveValues(OL: UserData): Observable<UserData[]> {
        return this.http.post<any>(this.globals.APIURL + '/MenuMaster/UserActive', OL);
    }

    GetEmployeeProfile(OL: EmployeeProfile): Observable<EmployeeProfile[]> {
        return this.http.post<any>(this.globals.APISAURL + '/UserApi/EmployeeProfile', OL);
    }

    UpdateEmployeeProfile(OL: EmployeeProfile): Observable<EmployeeProfile[]> {
        return this.http.post<any>(this.globals.APISAURL + '/UserApi/UpdateEmployeeProfile', OL);
    }
    getToken(OL: Login): Observable<Login[]> {

        const body = new URLSearchParams();
        body.set('client_id', 'FFD');
        body.set('client_secret', 'SWRlbnRpdHlAMTIzNDU=');
        body.set('grant_type', 'client_credentials');
        body.set('scope', 'freightforwardApi.read');
        body.set('Username', 'identity');
        body.set('Password', 'password');
        body.set('response_type', 'id_token');
        body.set('expires_in', '30');
        let options = {
            headers: new HttpHeaders().set(
                'Content-Type',
                'application/x-www-form-urlencoded'
            )
        };
        var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });

        //return this.http.post<Login[]>('https://localhost:44343/connect/token', body.toString(), options);
        //return this.http.post<Login[]>('https://token-navioindia.freighteiz.com/connect/token', body.toString(), options);
        return this.http.post<Login[]>('https://token-nikins.freighteiz.com/connect/token', body.toString(), options);
        //return this.http.post<Login[]>('https://token-naviouat.freighteiz.com/connect/token', body.toString(), options);
        //return this.http.post<Login[]>('https://odaktoken.odaksolutions.in/connect/token', body.toString(), options);
    }

    SaveAuthentication(OL: Login): Observable<Login[]> {

        return this.http.post<Login[]>(this.globals.APIURL + '/Home/SaveAuthentication', OL);
    }
    SendToken(OL: Login): Observable<Login[]> {

        return this.http.post<Login[]>(this.globals.APIURL + '/Home/GetAuthentication/', OL);
    }

    getDeleteToken(OL: Login): Observable<Login[]> {
        return this.http.post<Login[]>(this.globals.APIURL + '/Home/GetDeleteToken', OL);
    }

    getLandingApp(OL: Login): Observable<Login[]> {
        return this.http.post<Login[]>(this.globals.APIURL + '/Home/GetLandingApp', OL);
    }

    InsertFinYearReset(payload: any) {
        return this.http.post<any>(this.globals.APISAURL + '/FinYearReset/InsertFinYearReset', payload);
    }

    BindResetFinYearList(payload: any) {
        return this.http.post<any>(this.globals.APISAURL + '/FinYearReset/GetExFinYearList', payload);
    }

}


